import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { AgGridReact } from 'ag-grid-react';

export default class BoardVacancy extends Component {
    constructor(props) {
        super(props);

        document.title = "Vacant Seats";
        this.state = {
            boardVacancies: [],
            columnDefs: [
                { field: 'name', headerName: 'Board Name', filter: true, floatingFilter: true },
                { field: 'nbrVacancies', headerName: 'Number of Vacancies', filter: true, floatingFilter: true },
            ],
            defaultColDef: {
                sortable: true,
                autoHeight: true,
                resizable: true,
                floatingFilter: true
            },
        };
    }

    componentDidMount() {
        fetch('/api/boards/GetBoardsWithVacancies', {
            method: 'GET'
        })
        .then(resp => resp.json())
        .then(data => {
            this.setState({ boardVacancies: data });
        })
    }

    render() {
        return (
            <div>
                <Alert color='info'>
                    <p className='mb-0'>Below is a list of all boards with vacancies.</p>
                </Alert>
                <br />
                <div style={{ height: "70vh" }}>
                    <div className="ag-theme-alpine" style={{ width: "100%", height: "100%" }}>
                        <AgGridReact
                            ref={this.gridRef} // Ref for accessing Grid's API
                            rowData={this.state.boardVacancies} // Row Data for Rows
                            columnDefs={this.state.columnDefs} // Column Defs for Columns
                            defaultColDef={this.state.defaultColDef} // Default Column Properties
                            animateRows={true} // Optional - set to 'true' to have rows animate when sorted or filtered
                            onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
                            pagination={true}
                            paginationPageSize={10}
                            paginationPageSizeSelector={[10, 20, 50, 100]}
                        />
                    </div>
                </div>
            </div>
        )
    }
}